import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from '@/App.jsx'
import '@/index.css'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.3,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  environment: window.location.hostname === 'localhost' ? 'development' : 'production',
  ignoreErrors: [
    // Browser extensions (Google Translate, Grammarly, etc.) modify the DOM
    // and cause React to fail when reconciling. Not a bug in our code.
    // See: https://github.com/facebook/react/issues/17256
    "Failed to execute 'insertBefore' on 'Node'",
    "Failed to execute 'removeChild' on 'Node'",
    "The object can not be found here",
    "Node.removeChild",
    "Node.insertBefore",
  ],
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
